import { render, staticRenderFns } from "./TeamAttendanceCorrectionsCutOff.vue?vue&type=template&id=6310e0f7"
import script from "./TeamAttendanceCorrectionsCutOff.vue?vue&type=script&lang=js"
export * from "./TeamAttendanceCorrectionsCutOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports